import type { DevScenario } from '@arya/shared/domain';

import { http, HttpResponse, type RequestHandler } from 'msw';

import type { DevRoute } from './dev-route';
import { devScenarioRequest } from './dev-scenario-request';
import type { MockApiErrorBody } from './mock-api-error-body';

export interface DevScenarioEntry {
  readonly scenario: DevScenario;
  readonly handler: RequestHandler;
}

export const devScenarioEntry = <Path extends string>(
  scenario: DevScenario,
  route: DevRoute<Path>,
  answer: () => Response | Promise<Response>
): DevScenarioEntry => ({ scenario, handler: http.all(devScenarioRequest(route, scenario), answer) });

export const mockApiError = (
  status: number,
  message: string,
  data?: Record<string, unknown>,
  headers?: HeadersInit
): Response => {
  const body: MockApiErrorBody = { error: data === undefined ? { message } : { message, data } };
  return HttpResponse.json(body, { status, headers });
};
